export const SET_BATCH_TYPES = 'SET_BATCH_TYPES'
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const SET_REPORTS = 'SET_REPORTS'
export const SET_BATCH_NUM = 'SET_BATCH_NUM'

const initialState = {
  batchTypes: [],
  payments: [],
  reports: [],
  batchNum: '',
}

const PostDistributionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BATCH_TYPES:
      return {
        ...state,
        batchTypes: action.batchTypes,
      }
    case SET_PAYMENTS:
      return {
        ...state,
        payments: action.payments,
      }
    case SET_REPORTS:
      return {
        ...state,
        reports: action.reports,
      }
    case SET_BATCH_NUM:
      return {
        ...state,
        batchNum: action.batchNum,
      }
    default:
      return state
  }
}

export default PostDistributionReducer
